import React from 'react'
import ErrorDisplay from '../components/ErrorDisplay'
import { useGolferStore } from '../store/GolferStore'

const GroupEntryView = ({ onCheckboxChange, onSubmit, tempGroup }) => {
  const golfers = useGolferStore((state) => state.golfers)
  let errorStyle = {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontSize: '24px',
    height: '35px',
    lineHeight: '35px',
  }

  return (
    <div style={{ zIndex: '1' }}>
      <div style={{ display: 'flex', paddingBottom: '10px', height: '35px' }}>
        <ErrorDisplay customStyle={errorStyle} />
      </div>
      <form>
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
          }}
        >
          {golfers?.map((golfer) => (
            <div key={golfer.golferId} style={{ paddingLeft: '20px', width: '45%' }}>
              <label className="styledCheckbox golferGroupName">
                {golfer.golferName}
                <input
                  type="checkbox"
                  value={golfer.golferId}
                  checked={tempGroup?.indexOf(golfer.golferId) > -1}
                  onChange={() => onCheckboxChange(golfer.golferId)}
                />
                <span className="checkmark" />
              </label>
            </div>
          ))}
        </div>
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <button
            type="button"
            className="darkButton"
            style={{ padding: '8px', width: '150px' }}
            onClick={() => onSubmit()}
          >
            Done
          </button>
        </div>
      </form>
    </div>
  )
}

export default GroupEntryView
